import React from "react";
import LottoRowEditor from "./LottoRowEditor";
import CompactRow from "./CompactRow";
import ExpandArrow from "../buttons/ExpandArrow";

const LottoRow = (props) => {
    const createEditor = () => {
        return (
            <LottoRowEditor kenoCount={props.kenoCount} onClickNumber={props.onClickNumber} row={props.row} gameType={props.gameType}>

            </LottoRowEditor>
        );
    };
    const createCompact = () => {
        return (
            <CompactRow compactOnly={props.compactOnly} kenoCount={props.kenoCount} rowNr={props.rowNr} onRandom={props.onRandom} onDelete={props.onDelete} gameType={props.gameType} row={props.row}>
                
            </CompactRow>
        );
    };
    return (
        <div className="margin1 afterBorder05">
            <div className={(props.editorOpen && !props.compactOnly) ? "afterBorder05" : ""}>
                <div className="compactRow">
                    <ExpandArrow isExpanded={props.editorOpen && !props.compactOnly} onToggleExpanded={props.toggleEditor}></ExpandArrow>
                    {createCompact()}
                </div>
            </div>
            <div className="rowEditor">
                {(props.editorOpen && props.isExpanded && !props.compactOnly) && createEditor()}
            </div>
        </div>
    );
};

export default LottoRow;